import { Box, Icon } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { PageHeader } from '@m/components-ui/page-header';
import { Stepper } from '@m/components-ui/stepper';
import { ArrowBack, Close } from '@m/icons';
import { ProtectedRoutes } from 'apps/customer/routes/paths';

import type { StepConfig } from '@m/components-ui/stepper';

export interface OnboardingHeaderProps {
  disabledClose?: boolean;
  hideBack?: boolean;
  onBack?: () => void;
  onClose?: () => void;
  onHelp?: () => void;
  showClose?: boolean;
  steps?: StepConfig[];
}

export default function OnboardingHeader({
  disabledClose = false,
  hideBack = false,
  onBack,
  onClose,
  onHelp,
  showClose = false,
  steps,
}: OnboardingHeaderProps) {
  const history = useHistory();
  const showLeftIcon = showClose || !hideBack;
  let handleLeftIconClick: (() => void) | undefined;
  if (showClose && !disabledClose) {
    handleLeftIconClick = onClose ?? onBack;
  } else if (!showClose) {
    handleLeftIconClick = onBack;
  }

  return (
    <>
      <PageHeader
        leftIcon={
          showLeftIcon ? (
            <Icon
              as={showClose ? Close : ArrowBack}
              width={6}
              height={6}
              color="text.primary"
              opacity={showClose && disabledClose ? 0.4 : 1}
            />
          ) : (
            <Box w="full" h="full" />
          )
        }
        onLeftIconClick={showLeftIcon ? handleLeftIconClick : undefined}
        onLogoClick={() => history.push(ProtectedRoutes.HomePage)}
        rightAction={onHelp ? { label: 'Help', onClick: onHelp } : undefined}
      />
      {steps && steps.length > 0 && <Stepper steps={steps} />}
    </>
  );
}
